import { IMembership, IUser } from '@/types';
import { addDays, isAfter, parseISO } from 'date-fns';

type AccessUser = Partial<Pick<IUser, 'admin' | 'got_free_trial' | 'teacher' | 'translator'>>;
type AccessMembership = Pick<IMembership, 'validity'>;

// The server compares dates in its own timezone and the browser in the user's, so they can differ by a few hours at the 2-day and 1-day limits.
function hasMembershipWithinTwoDays(
  memberships: AccessMembership[] | null | undefined,
  now: Date,
): boolean {
  if (!memberships) return false;
  return memberships.some((membership) => isAfter(addDays(parseISO(membership.validity), 2), now));
}

function hasFreeTrialWithinOneDay(user: AccessUser, now: Date): boolean {
  if (!user.got_free_trial) return false;
  return isAfter(addDays(parseISO(user.got_free_trial), 1), now);
}

// Mirrors igs3-server src/middleware/trainingSystemMembership.ts, which guards
// GET /api/discuss and PUT /api/trainingSystem/studied.
function hasTrainingSystemAccess(
  isLoggedIn: boolean,
  user: AccessUser | null | undefined,
  memberships: AccessMembership[] | null | undefined,
  now: Date,
): boolean {
  if (!isLoggedIn) return false;
  if (!user) return false;
  // No author check: the server's login token never carries author, so its author check is never true.
  if (user.admin) return true;
  if (user.teacher) return true;
  if (user.translator) return true;
  if (hasMembershipWithinTwoDays(memberships, now)) return true;
  if (hasFreeTrialWithinOneDay(user, now)) return true;
  return false;
}

export default hasTrainingSystemAccess;
